import { Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-holiday-calendar',
    templateUrl: './holiday-calendar.component.html',
    styleUrl: './holiday-calendar.component.scss',
    imports: [NgFor, NgIf]
})
export class HolidayCalendarComponent implements OnInit {
  @Input() closeHolidayList!: () => void;
  tabs: string[] = [];
  tableHeaders: string[] = ['Day', 'Dates'];
  activeTabIndex: number = 0;
  tableData: any[] = [];
  holidayDetails: any;
  noDataMessage = "The holiday list for this year has not been generated yet. Please contact your admin for further assistance.";

  ngOnInit() {
    this.getHolidays();
  }

  constructor(  private elementRef: ElementRef){}

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (this.closeHolidayList && !this.elementRef.nativeElement.contains(event.target)) {
      this.closeHolidayList()
    }
  }

  getHolidays() {
    const holidayList = Helpers.brandDetails?.conversation_config.actions.business_timings.holidays;
    const currentYear = new Date().getFullYear();
    const validYears = [currentYear - 1, currentYear, currentYear + 1];

    this.holidayDetails = this.groupAndSortDatesByYear(holidayList, validYears);
    this.tabs = validYears.map(year => year.toString());
    this.activeTabIndex = this.tabs.indexOf(currentYear.toString());
    this.tableData = this.holidayDetails[this.tabs[this.activeTabIndex]] || [];
  }

  selectTab(index: number) {
    this.activeTabIndex = index;
    this.tableData = this.holidayDetails[this.tabs[index]] || [];
  }

  groupAndSortDatesByYear(dates: string[], validYears: number[]) {
    const groupedDates: Record<number, string[]> = {};

    dates.forEach(dateString => {
      const year = new Date(dateString).getFullYear();
      if (validYears.includes(year)) {
        if (!groupedDates[year]) {
          groupedDates[year] = [];
        }
        groupedDates[year].push(dateString);
      }
    });

    validYears.forEach(year => {
      if (groupedDates[year]) {
        groupedDates[year].sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
      }
    });

    return groupedDates;
  }

  getDayOfWeek(date: string): string {
    const d = new Date(date);
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return daysOfWeek[d.getDay()];
  }

  getFormattedDate(date: string): string {
    const d = new Date(date);
    const day = d.getDate();
    const month = d.toLocaleString('en-US', { month: 'long' });

    const ordinalSuffix = (n: number): string => {
      if (n >= 11 && n <= 13) return 'th';
      switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };

    return `${day}${ordinalSuffix(day)} ${month}`;
  }

  closePanel(event:Event){
    event.stopPropagation()
    if(this.closeHolidayList){
      this.closeHolidayList()
    }
  }



}
